import { LegalLayout, H2, P, UL, CONTACT_EMAIL, COMPANY, PRODUCT } from "@/components/LegalLayout";

export default function DataDeletion() {
    const subject = encodeURIComponent("Data Deletion Request");
    const body = encodeURIComponent(
        "I would like to request deletion of my personal data.\n\n" +
        "WhatsApp / phone number: \n" +
        "Business / workspace you contacted (if known): \n" +
        "Any additional details: \n"
    );
    return (
        <LegalLayout eyebrow="Legal" title="User Data Deletion" lastUpdated="June 2026" testid="data-deletion-page">
            <P>
                {COMPANY} operates {PRODUCT}, a business communications platform. This page explains how you can
                request deletion of your personal data that we process through the Service, including data
                related to WhatsApp conversations handled via the WhatsApp Business Cloud API.
            </P>

            <H2>How to Request Deletion</H2>
            <P>
                To request deletion of your data, email us at{" "}
                <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`} className="font-semibold text-brand hover:underline" data-testid="data-deletion-email">
                    {CONTACT_EMAIL}
                </a>{" "}
                with the subject line <span className="font-semibold text-ink">“Data Deletion Request”</span> and
                include the following so we can locate and verify your data:
            </P>
            <UL items={[
                "The WhatsApp or phone number you used to contact the business.",
                "The name of the business/workspace you interacted with, if known.",
                "Any additional details that will help us identify your records.",
            ]} />

            <div className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm">
                <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-stone2">Send your request to</div>
                <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`} className="mt-1 block font-heading text-lg font-bold text-brand hover:underline" data-testid="data-deletion-email-button">
                    {CONTACT_EMAIL}
                </a>
            </div>

            <H2>What Happens Next</H2>
            <UL items={[
                "We acknowledge deletion requests and may ask for information to verify your identity or ownership of the number, to protect against fraudulent requests.",
                "Once verified, we delete or anonymize the personal data we hold about you within a reasonable period, typically within 30 days.",
                "This process is completely free of charge — we never charge a fee for data access or deletion requests.",
                "Deletion requests are honored for all users regardless of location.",
                "We may retain limited information where required by law, for security, or to resolve disputes; such data is deleted once the retention need ends.",
            ]} />

            <H2>A Note on Controllership</H2>
            <P>
                Because {PRODUCT} is a business-to-business platform, the businesses that use the Service are the
                controllers of the End-User data they process. If your data was collected by a specific business,
                we may coordinate with that business to fulfil your request, or direct you to contact them where
                they control the data.
            </P>

            <H2>Contact</H2>
            <P>
                For any questions about data deletion or your privacy, contact {COMPANY} at{" "}
                <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-brand hover:underline">{CONTACT_EMAIL}</a>.
                See also our{" "}
                <a href="/privacy-policy" className="font-semibold text-brand hover:underline">Privacy Policy</a>.
            </P>
        </LegalLayout>
    );
}
